import React from 'react'

export default function ImageCard() {
    return (

        <div className="d-flex justify-content-center" style={{ width: "100%", height: "100%" }}>
            <div className="spinner-grow text-primary  m-5" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>

    )
}
